import { Component, OnInit, NgZone, ViewEncapsulation } from '@angular/core';
import { CommonService } from 'app/services/common.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { InternshipModel } from './internship.model';
import { InternshipService } from './internship.service';
import { BaseListComponent } from 'app/common/base-list/base.list.component';
import { fuseAnimations } from '@fuse/animations';
import { DialogService } from 'app/common/confirm-dialog/dialog.service';

@Component({
  selector: 'data-list-view',
  templateUrl: './internship.component.html',
  styleUrls: ['./internship.component.scss'],
  animations: fuseAnimations,
  encapsulation: ViewEncapsulation.None
})

export class InternshipComponent extends BaseListComponent<InternshipModel> implements OnInit {
  constructor(public commonService: CommonService,
    public router: Router,
    public routeParams: ActivatedRoute,
    public snackBar: MatSnackBar,
    public zone: NgZone,
    private dialogService: DialogService,
    private internshipService: InternshipService) {
    super(commonService, router, routeParams, snackBar, zone);
  }

  ngOnInit(): void {
    this.internshipService.GetAllByCriteria(this.SearchBy).subscribe(response => {
      this.displayedColumns = [
        'StateName',
        'DistrictCode',
        'BlockId',
        'PinCode',
        'SchoolId',
        'SchoolName',
        'SchoolCategoryId',
        'Udise',
        'DateOfCommencement',
        'DateOfCompletion',
        'Sector',
        'JobRole',
        'VTPName',
        'VCName',
        'VTName',
        'VTContactNumber',
        'EmployerName',
        'TypeOfBusiness',
        'EmployerContactName',
        'EmployerDesignation',
        'EmployerContactPhone',
        'StudentRollNumber',
        'FullName',
        'Gender',
        'ClassName',
        'Mobile2',
        'WorkingDays',
        'TotalHoursCovered',
        'IsConsentApproved',
        'LetterSignedByEmployer',
        'AttendanceMaintained',
        'DailyDairyMaintained',
        'OJTCertificatePresent',
        'ReportCreatedByStudent',
        'Remarks',
        'Attachment5',
        'Attachment10',
        'Attachment11',
        'Attachment',
        'Attachment2',
        'Attachment3',
        'Attachment4',
        'Attachment6',
        'Attachment7',
        'Attachment8',
        'Attachment9',
        'Actions'
      ];

      this.tableDataSource.data = response.Results;
      this.tableDataSource.sort = this.ListSort;
      this.tableDataSource.paginator = this.ListPaginator;
      this.tableDataSource.filteredData = this.tableDataSource.data;

      this.zone.run(() => {
        if (this.tableDataSource.data.length == 0) {
          this.showNoDataFoundSnackBar();
        }
      });
      this.IsLoading = false;
    }, error => {
      console.log(error);
    });
  }

  onDeleteInternship(internshipId: string) {
    this.dialogService
      .openConfirmDialog(this.Constants.Messages.DeleteConfirmationMessage)
      .afterClosed()
      .subscribe(confResp => {
        if (confResp) {
          this.internshipService.deleteInternshipById(internshipId)
            .subscribe((internshipResp: any) => {

              this.zone.run(() => {
                if (internshipResp.Success) {
                  this.showActionMessage(
                    this.Constants.Messages.RecordDeletedMessage,
                    this.Constants.Html.SuccessSnackbar
                  );
                }
                this.ngOnInit();
              }, error => {
                console.log('Internship deletion errors =>', error);
              });

            });
          this.ngOnInit();
        }
      });
  }
}
